/** Namespace `users` (Benutzerverwaltung) — befüllt während der Komponenten-Migration. */
export const users = {
  de: {
    users: {
      title: 'Benutzerverwaltung',
      roleExplanation: '<b>Admin</b> kann Benutzer verwalten. <b>Bearbeiter</b> kann nur normal arbeiten.',
      newUser: 'Neuer Benutzer',
      loading: 'Lade Benutzer…',
      saving: 'Speichern…',
      create: 'Anlegen',
      emptyTitle: 'Noch keine Benutzer',
      emptyDescription: 'Lege Benutzer an, damit sich weitere Personen anmelden können.',
      colUser: 'Benutzer',
      role: 'Rolle',
      roleAdmin: 'Admin',
      roleEditor: 'Bearbeiter',
      // Bereichsrechte
      permissionsLabel: 'Bereichsrechte',
      permissionsHint: 'Lege fest, welche Bereiche dieser Bearbeiter sehen und nutzen darf. Admins haben immer Zugriff auf alles.',
      permissionsAdminNote: 'Admins haben automatisch Zugriff auf alle Bereiche und Einstellungen.',
      permInvoicesViewHint: 'Belege ansehen und als PDF öffnen',
      permInvoicesManage: 'Belege erstellen/bearbeiten',
      permInvoicesManageHint: 'Angebote/Rechnungen anlegen, bearbeiten, finalisieren und versenden',
      permCommunications: 'Kommunikation / E-Mail-Versand',
      permCommunicationsHint: 'E-Mails an Patienten aus der Akte senden und fehlgeschlagene erneut senden',
      youBadge: '(du)',
      setPassword: 'Passwort setzen',
      cannotDeleteSelf: 'Du kannst dich nicht selbst löschen',
      // Modal
      editUser: 'Benutzer bearbeiten',
      createUser: 'Neuen Benutzer anlegen',
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      username: 'Benutzername *',
      emailRequired: 'E-Mail *',
      cannotChangeOwnRole: 'Du kannst deine eigene Rolle nicht ändern',
      languageLabel: 'Sprache',
      passwordRequired: 'Passwort * (min. 8 Zeichen)',
      activeLoginAllowed: 'Aktiv (Login erlaubt)',
      // Passwort-Reset-Modal
      setPasswordHint: 'Setze ein neues Passwort für <b>{{username}}</b>. Beim nächsten Login wird das neue Passwort verwendet.',
      newPasswordPlaceholder: 'Neues Passwort (min. 8 Zeichen)',
      setButton: 'Setzen',
      // Toasts / Fehler
      errorLoad: 'Konnte Benutzer nicht laden.',
      errorRequiredFields: 'Bitte alle Pflichtfelder ausfüllen.',
      errorPasswordLength: 'Passwort muss mindestens 8 Zeichen haben.',
      userUpdated: 'Benutzer aktualisiert.',
      userCreated: 'Benutzer angelegt.',
      userDeleted: 'Benutzer gelöscht.',
      passwordSet: 'Passwort gesetzt.',
      errorSave: 'Speichern fehlgeschlagen.',
      errorCreate: 'Anlegen fehlgeschlagen.',
      errorDelete: 'Löschen fehlgeschlagen.',
      errorDeleteSelf: 'Du kannst dich nicht selbst löschen.',
      errorPasswordReset: 'Passwort-Reset fehlgeschlagen.',
      confirmDelete: 'Benutzer „{{username}}“ wirklich löschen?',
    },
  },
  es: {
    users: {
      title: 'Gestión de usuarios',
      roleExplanation: '<b>Administrador</b> puede gestionar usuarios. <b>Editor</b> solo puede trabajar con normalidad.',
      newUser: 'Nuevo usuario',
      loading: 'Cargando usuarios…',
      saving: 'Guardando…',
      create: 'Crear',
      emptyTitle: 'Aún no hay usuarios',
      emptyDescription: 'Cree usuarios para que más personas puedan iniciar sesión.',
      colUser: 'Usuario',
      role: 'Rol',
      roleAdmin: 'Administrador',
      roleEditor: 'Editor',
      // Permisos por área
      permissionsLabel: 'Permisos por área',
      permissionsHint: 'Defina qué áreas puede ver y usar este editor. Los administradores siempre tienen acceso a todo.',
      permissionsAdminNote: 'Los administradores tienen acceso automático a todas las áreas y ajustes.',
      permInvoicesViewHint: 'Ver facturas y abrir el PDF',
      permInvoicesManage: 'Crear/editar facturas',
      permInvoicesManageHint: 'Crear, editar, finalizar y enviar presupuestos/facturas',
      permCommunications: 'Comunicación / envío de correos',
      permCommunicationsHint: 'Enviar correos a pacientes desde la historia clínica y reenviar los fallidos',
      youBadge: '(usted)',
      setPassword: 'Establecer contraseña',
      cannotDeleteSelf: 'No puede eliminarse a sí mismo',
      // Modal
      editUser: 'Editar usuario',
      createUser: 'Crear nuevo usuario',
      firstName: 'Nombre *',
      lastName: 'Apellidos *',
      username: 'Nombre de usuario *',
      emailRequired: 'Correo electrónico *',
      cannotChangeOwnRole: 'No puede cambiar su propio rol',
      languageLabel: 'Idioma',
      passwordRequired: 'Contraseña * (mín. 8 caracteres)',
      activeLoginAllowed: 'Activo (acceso permitido)',
      // Modal de restablecimiento de contraseña
      setPasswordHint: 'Establezca una nueva contraseña para <b>{{username}}</b>. Se usará en el próximo inicio de sesión.',
      newPasswordPlaceholder: 'Nueva contraseña (mín. 8 caracteres)',
      setButton: 'Establecer',
      // Toasts / Errores
      errorLoad: 'No se pudieron cargar los usuarios.',
      errorRequiredFields: 'Rellene todos los campos obligatorios.',
      errorPasswordLength: 'La contraseña debe tener al menos 8 caracteres.',
      userUpdated: 'Usuario actualizado.',
      userCreated: 'Usuario creado.',
      userDeleted: 'Usuario eliminado.',
      passwordSet: 'Contraseña establecida.',
      errorSave: 'Error al guardar.',
      errorCreate: 'Error al crear.',
      errorDelete: 'Error al eliminar.',
      errorDeleteSelf: 'No puede eliminarse a sí mismo.',
      errorPasswordReset: 'Error al restablecer la contraseña.',
      confirmDelete: '¿Eliminar realmente al usuario «{{username}}»?',
    },
  },
};
